import Vue from 'vue'
import Vuex from 'vuex'
import Jwt from 'jsonwebtoken';

Vue.use(Vuex)

export default {
  state : {
    token: localStorage.getItem('user-token') || '',
    user: localStorage.getItem('user-token')? Jwt.decode(localStorage.getItem('user-token')) : null
    
  },
  mutations: {
    logout(state) {
      state.token = null
      state.user = null
    },
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('user-token', token)
    },
  },
  actions: {
    logout : ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        commit('logout');
        localStorage.removeItem('user-token');
        resolve();
      })
    }
  },
  getters: {
    user: state => state.user,
    userRoles: state => {
      try{
        return state.user.role.split(',')
      } catch (e) {
        return []
      }
    },
    features: state => {
      try{
        if (typeof state.user.features === "undefined") {
          return [];
        }
        return state.user.features
      } catch (e) {
        return []
      }
    },
    token: state => state.token,
    isAuthenticated: state => !!state.token,
  },
}
